import{jsx as t}from"react/jsx-runtime";import{DetailsRow as r}from"./components/DetailsRow.js";const o=o=>{if(!o)return null;const e=o.item;return t(r,{...o,id:e.id})};export{o as DtoDetailsRow};
//# sourceMappingURL=DtoDetailRow.js.map
